import { Routes } from '@angular/router';
import { PageKey } from '../../../shared/services/page/models/page.key';
import { canActivate } from '../../../shared/guard/guard';
import { HeaderEnum, PermissionEnum } from '../../../../environments/shared-environment/permission';

export const manualAnalysisRoute: Routes = [{
  path: 'manual-analysis',
  canActivateChild: [() => canActivate(HeaderEnum.MANUAL_ANALYSIS, PermissionEnum.VIEW)],
  loadComponent: () => import('./manual-analysis.component').then(m => m.ManualAnalysisComponent),
  children: [
    {
      path: '',
      redirectTo: 'list',
      pathMatch: 'full'
    },
    {
      path: 'create',
      loadComponent: () => import('./create/create.component').then(m => m.CreateManualAnalysisComponent),
      data: {
        title: 'Criar Análise',
        key: PageKey.ANALYSIS
      },
    },
    {
      path: 'create/manualy',
      loadComponent: () => import('./create/manualy/manualy.component').then(m => m.CreateAnalysisManualyComponent),
      data: {
        title: 'Criar Análise Manualmente',
        key: PageKey.ANALYSIS
      },
    },
    {
      path: 'list',
      loadComponent: () => import('./list/list.component').then(m => m.ListManualAnalysisComponent),
      data: {
        title: 'Análises',
        key: PageKey.ANALYSIS,
        fullscreen: true
      },
    },
    {
      path: 'review/:id',
      loadComponent: () => import('./review/review.component').then(m => m.ReviewManualAnalysisComponent),
      data: {
        title: 'Revisar Análise',
        key: PageKey.ANALYSIS
      },
    },
    {
      path: 'action-plan/list',
      loadComponent: () => import('./action-plan/list/list.component').then(m => m.ListActionPlanComponent),
      data: {
        title: 'Listar Planos de Ação',
        key: PageKey.ANALYSIS,
        fullscreen: true
      },
    },
    {
      path: 'action-plan/:id',
      loadComponent: () => import('./action-plan/create/create.component').then(m => m.CreateActionPlanComponent),
      data: {
        title: 'Criar Plano de Ação',
        key: PageKey.ANALYSIS,
        fullscreen: true
      },
    },
    {
      path: 'action-plan/:id/update',
      loadComponent: () => import('./action-plan/create/create.component').then(m => m.CreateActionPlanComponent),
      data: {
        title: 'Atualizar Plano de Ação',
        key: PageKey.ANALYSIS,
        fullscreen: true
      },
    },
    {
      path: 'my-analysis',
      loadComponent: () => import('./analysis/analysis.component').then(m => m.UserAnalysisComponent),
      data: {
        title: 'Minhas Análises',
        key: PageKey.ANALYSIS
      },
    },
  ]
}];
